import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "boxWithCircleInside",
    iconColor: "white",
    text: "Developing end-to-end RAI\npractice across the organization,\nwith a mix of frameworks, advisory\nservices, tailored best practices,\nplaybooks, and technical guardrails\nto institute strong AI governance",
    listItemCustomStyle: { width: "410px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "boxAndAdjustableWrench",
    iconColor: "white",
    text: "In the event of unforeseen AI-\nrelated disasters, engage in swift\nremediation via crisis management\nprotocols, or institute proper\ndisaster recovery mechanisms",
    listItemCustomStyle: { width: "414px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const DATA_BENEFITS = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "Infosys ai3s - steer",
  titleNumber: "3.",
  text: "Advisory and consulting services to enable enterprises to advance their \nRAI journey and reduce risks. It solves AI governance challenges and aids \nin managing a dedicated Responsible AI practice.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Challenges Solved",
    onClick: () => setCurrentPage(305),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(303),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_04.png",
};

export default DATA_BENEFITS;
